import React, { useState } from 'react'

const PasswordValidator = ({handleLogin }) => {
    const [password, setPassword] = useState('')
   
    return (
    <div>
        <form>

        <h1>Password eingeben</h1>
        <input type="password" value={password} onChange={(event) => setPassword(event.target.value)}/>
        <button onClick={() => handleLogin(password)} type="submit">Bestätigen</button>
        </form>
    </div>
    )
}

export default PasswordValidator